import { fetchPost } from './CommonServiceUtils';
import Constants from '../Constants';

const BASE_URL = `${Constants.BASE_URL}identityservice`;

const updatePassword = (payload) => {
    return fetchPost(`${BASE_URL}/users/updatePassword`, payload)
};

export {updatePassword};